export const OPTIONS = {
  appName: 'Customer Account',
  backend: process.env.REACT_APP_BACKEND_URL,
  sso_url: process.env.REACT_APP_SSO_URL
}
